import { createContext, useContext } from 'react';
import { Firm } from '@/types';

export interface FirmContextType {
    firm: Firm | null;
    loading: boolean;
    error: Error | null;
    refreshFirm: () => Promise<void>;
}

export const FirmContext = createContext<FirmContextType | undefined>(undefined);

export function useFirm() {
    const context = useContext(FirmContext);
    if (context === undefined) {
        throw new Error('useFirm must be used within a FirmProvider');
    }
    return context;
}
